var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 29,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M12.444 14.036 8.39 21.059l-1.75 3.024L0 20.248l3.595-6.226L0 7.796l6.643-3.828L8.31 6.85l4.131 7.157q0 .015.002.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M33.734 14.024a14.02 14.02 0 0 1-14.022 14.019H8.998l1.1-1.897 2.896-5.02h6.718a7.103 7.103 0 0 0 7.224-7.104 7.106 7.106 0 0 0-7.224-7.104h-6.795l-2.82-4.882L8.923 0h10.79a14.02 14.02 0 0 1 14.02 14.024z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M44.79 8.211h4.658c3.902 0 6.37 2.174 6.37 5.643s-2.451 5.576-6.37 5.576H44.79zm4.658 9.139c2.503 0 4.075-1.364 4.075-3.524s-1.59-3.538-4.075-3.538h-2.502v7.062zm9.219-9.14h10.651v2.078h-8.491V12.6h7.56v2.077h-7.56v2.641l8.491.018v2.077H58.667zm14.103 0h10.65v2.078h-8.49V12.6h7.56v2.077h-7.56v2.641l8.49.018v2.077H72.77zm12.966 11.487h7.647v2.076h-7.647zm13.238-5.947-4.088-5.54h2.845l2.607 3.539 2.468-3.538h2.849l-4.005 5.317 4.351 5.885h-2.849l-2.884-3.919-2.727 3.919h-2.846z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 12.444,
    y1: 14.022,
    y2: 14.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f85d31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 8.923,
    x2: 33.734,
    y1: 14.021,
    y2: 14.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0eb4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b75c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.7fb3e34983b664b3a3e2b3fd48619fd7.svg";
export { ForwardRef as ReactComponent };